import { createFileRoute } from '@tanstack/react-router'

import { ProviderSwitchesPage } from '#/modules/communication/provider-switches-page'

export const Route = createFileRoute('/_shell/provider-switches')({
  component: ProviderSwitchesPage,
})
